import * as types from '../constants/ActionTypes';
import _ from 'lodash';

const initialState = {
	item: null,
	list: [],
	pagination: null,
	isFetchingItem: false,
	isFetchingList: false,
	error: null,
};

export default function subdivisions(state = initialState, action) {
	switch (action.type) {
		case types.REQUEST_SUBDIVISION_LIST:
			return {
				...state,
				isFetching: true,
				error: {},
			};

		case types.RECEIVE_SUBDIVISION_LIST:
			return {
				...state,
				list: action.response.results,
				pagination: action.response.pagination,
				isFetching: false,
			};

		case types.REQUEST_SUBDIVISION:
			return {
				...state,
				item: null,
				isFetchingItem: true,
				error: null,
			};

		case types.RECEIVE_SUBDIVISION:
			return {
				...state,
				item: action.subdivision,
				isFetchingItem: false,
			};

		case types.RECEIVE_SUBDIVISION_ERROR:
			return {
				...state,
				isFetchingItem: false,
				error: action.error,
			};

		case types.RECEIVE_SUBDIVISION_LIST_ERROR:
			return {
				...state,
				isFetching: false,
				error: action.error,
			};

		case types.SUBMIT_EDIT_SUBDIVISION:
			return {
				...state,
				isFetching: false,
				error: {},
			};

		case types.RESOLVE_EDIT_SUBDIVISION: {
			let list = state.list.slice();
			let i = _.findIndex(list, sub => {
				return sub.id == action.subdivision.id;
			});
			list[i].isFeedEnabled = action.subdivision.isFeedEnabled;
			return {
				...state,
				list,
			};
		}

		case types.RESOLVE_EDIT_SUBDIVISION_ERROR:
			return {
				...state,
				isFetching: false,
				error: action.error,
			};

		case types.SUBMIT_UPDATE_SUBDIVISION_STATUS:
			return {
				...state,
				isFetching: true,
				redirect: false,
			};

		case types.RESOLVE_UPDATE_SUBDIVISION_STATUS: {
			let list = [];
			_.forEach(state.list, sub => {
				sub.isFeedEnabled = action.isFeedEnabled;
				list.push(sub);
			});

			return {
				...state,
				list,
				isFetching: false,
			};
		}

		case types.RESOLVE_UPDATE_SUBDIVISION_STATUS_ERROR:
			return {
				...state,
				isFetching: false,
				redirect: false,
				error: action.error,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/reducers/subdivisions.js